// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3I4jk","rootSuccess":"CompleteLink_rootSuccess__27vrc","rootFailure":"CompleteLink_rootFailure__3NVRz","isDisabled":"CompleteLink_isDisabled__wLQRt"};